class ProductMarketplaceFinanceRevenue{
    constructor({market, base,}){
        this.market = market;
        this.base = base;
    }
}
export { ProductMarketplaceFinanceRevenue };